import { httpPost, httpDownload, httpGet, httpPostFile } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import { convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';

import {
    getContract 
    , setDefaultContract
    , setContractError
    , setContractColSearchStr
    , sortContractList
    , setContractListPageSizes
    , setContractFilter
    , applyContractFilter
    , getContractComments
    , insertToContractComment
    , resetContractComments
} from '../../../constants/model-reducers/external/finance/contract.settings';

const defaultState = () => ({
    isContractLoaded: false,
    isContractError: false,
    contractItems: DEFAULT_TABLE_RESULT_MODEL,
    contractColSort: '',
    contractIsSortedAsc: true,
    //Contract Filters
    contractFilterData: [],
    contractFilterLoaded: false,
    contractTableFilterList: [],
    contractTableFilterApply: false,
    contractComments: [],
    pageIndex: 1
});

const initialState = defaultState();

export const contractActions = {
    setDefaultContract: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultContract,
            contractItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },

    resetContractComments: () => (dispatch) => {
        dispatch({
            type: resetContractComments,
        })
    },

    getContract: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().contract.contractItems;
        const { contractColSort, contractIsSortedAsc, contractTableFilterList, contractTableFilterApply } = state().contract;
        const headersToSend = pageUnmount ? {} : { ...Headers };

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: headersToSend,
                SortedColumnName: contractColSort,
                IsSortAscending: contractIsSortedAsc,
                TableFilterList: contractTableFilterList,
                ApplyFilter: contractTableFilterApply
            };
            
            var contractItems = await httpPost('external/finance/getContractItems', data);

            dispatch({
                type: getContract,
                contractItems: Object.keys(contractItems).length > 0 ? contractItems : DEFAULT_TABLE_RESULT_MODEL,
                isContractLoaded: true,
                isContractError: false
            });
        }
        catch (e) {
            dispatch({
                type: setContractError,
                isContractError: true,
                isContractLoaded: false
            })
        }
    },

    extractContract: () => async (dispatch, state) => {
        const { Headers } = state().contract.contractItems;
        const { contractColSort, contractIsSortedAsc, contractTableFilterApply, contractTableFilterList } = state().contract;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Contract Extract – ${formattedTimeZoneDate}`;
        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },

            SortedColumnName: contractColSort,
            IsSortAscending: contractIsSortedAsc,
            TableFilterList: contractTableFilterList,
            ApplyFilter: contractTableFilterApply,


        };
        
        httpDownload('external/finance/getAllContractExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    setContractColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { contractItems } = state().contract;
        var contractListUpd = {
            ...contractItems,
            "Headers": {
                ...contractItems.Headers,
                [key]: {
                    ...contractItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setContractColSearchStr,
            data: contractListUpd,
            isContractLoaded: true,
            isContractError: false
        });
    },

    sortContractList: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().contract.contractItems.Pagination;
        const { contractItems, contractTableFilterList, contractTableFilterApply } = state().contract;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: contractItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...contractItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: contractTableFilterList,
            ApplyFilter: contractTableFilterApply
        };

        var resContractList = await httpPost('external/finance/getContractItems', data);
        if (resContractList.ok === false) {
            dispatch({
                type: setContractError,
                isContractError: true,
                isContractLoaded: false
            });
        } else {
            dispatch({
                type: sortContractList,
                contractItems: Object.keys(resContractList).length > 0 ? resContractList : DEFAULT_TABLE_RESULT_MODEL,
                contractColSort: columnClicked,
                contractIsSortedAsc: isSortedAsc,
                isContractLoaded: true
            })
        }
    },

    resizeContractPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setContractListPageSizes,
            pageSize: parseInt(pageSize),
        });
    },

    saveContractCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().contract.contractItems;
        const { contractColSort, contractIsSortedAsc } = state().contract;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.ContractFinanceManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/finance/saveContractCustomizeColumns', customizeFormData)
            dispatch({
                type: setContractError,
                isContractError: false,
                isContractLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: contractColSort,
                IsSortAscending: contractIsSortedAsc
            };
            
            var contractItems = await httpPost('external/finance/getContractItems', data);

            dispatch({
                type: getContract,
                contractItems: Object.keys(contractItems).length > 0 ? contractItems : DEFAULT_TABLE_RESULT_MODEL,
                isContractLoaded: true,
                isContractError: false
            });
        }
        catch (e) {
            dispatch({
                type: setContractError,
                isContractError: true,
                isContractLoaded: false
            });
        }
    },

    addContractFilter: (tableFilter) => (dispatch, state) => {
        const { contractTableFilterList } = state().contract;
        var filterList = [...contractTableFilterList, tableFilter];

        dispatch({
            type: setContractFilter,
            filterList: filterList
        })
    },

    removeContractFilter: (removeIndex) => (dispatch, state) => {
        const { contractTableFilterList } = state().contract;

        var filterList = contractTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setContractFilter,
            filterList: filterList
        })
    },

    applyContractFilter: (isApply) => (dispatch, state) => {
        const { contractTableFilterList } = state().contract;

        dispatch({
            type: applyContractFilter,
            applyFilter: isApply,
            filterList: isApply ? contractTableFilterList : []
        });
    },

    getContractComments: (financeContractID, pageIndex = 1, pageSize = 5, bypassPagination = true) => async (dispatch, state) => {
        
        const existingComments = state().contract?.contractComments || [];

        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;

        const url = `external/finance/getContractComments/${pageIndex}/${pageSize}?financeContractID=${financeContractID}`
        + (lastCommentId ? `&lastCommentId=${lastCommentId}` : "");

        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getContractComments,
                contractComments:res.contractComments,
                isContractLoaded: true,
                isContractError: false,
                pageIndex: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setContractError,
                isContractError: true,
                isContractLoaded: false
            });
        }
    },

    postContractComments: (financeContractID, filename, fileData, comment) => async (dispatch, state) => {

        const { pageIndex } = state().contract;
        const addIndex = pageIndex + 1;

        var formData = new FormData();
        var user = JSON.parse(sessionStorage.getItem('User'));

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("FinanceContractID", financeContractID);

        var res = await httpPostFile('external/finance/setContractComments', formData);

        if (res != null) {
            dispatch({
                type: insertToContractComment,
                contractComments: res?.contractComments,
                isContractLoaded: true,
                isContractError: false,
            });
        } else {
            dispatch({
                type: setContractError,
                isContractError: true,
                isContractLoaded: false
            });
        }
    },

    deleteContractComments: (commentId) => async (dispatch, state) => {
        const userId = sessionStorage.getItem("UserID");
        const res = await httpPost(`external/finance/contractDeleteComment/${commentId}/${userId}`);
    
        if (res == null) {
            dispatch({
                type: setContractError,
                isContractError: true,
                isContractLoaded: false
            });
        }
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getContract:
            return {
                ...state,
                contractItems: action.contractItems,
                isContractLoaded: action.isContractLoaded,
                isContractError: action.isContractError
            };
        case setContractError:
            return {
                ...state,
                isContractLoaded: action.isContractLoaded,
                isContractError: action.isContractError
            };
        case setContractColSearchStr:
            return {
                ...state,
                contractItems: action.data,
                isContractLoaded: action.isContractLoaded,
                isContractError: action.isContractError
            };
        case sortContractList:
            return {
                ...state,
                contractItems: action.contractItems,
                contractColSort: action.contractColSort,
                contractIsSortedAsc: action.contractIsSortedAsc,
                isContractLoaded: action.isContractLoaded
            };
        case setContractListPageSizes:
            return {
                ...state,
                contractItems: {
                    ...state.contractItems,
                    Pagination: {
                        ...state.contractItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            };
        case setContractFilter:
            return {
                ...state,
                contractTableFilterList: action.filterList,
            };
        case applyContractFilter:
            return {
                ...state,
                contractTableFilterApply: action.applyFilter,
                contractTableFilterList: action.filterList
            };
        case getContractComments:
            return {
                ...state,
                contractComments: [...state.contractComments, ...action.contractComments],
                hasMoreComments: action.hasMoreData,
                pageIndex: action.pageIndex
            };

        case insertToContractComment: {
            const combinedComments = [
                ...action.contractComments,
                ...state.contractComments
            ];
            const currentVisibleCount = state.contractComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !== 1;
            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments;
            }

            return {
                ...state,
                contractComments: combinedComments.length === 1 ? action.contractComments : updatedComments,
                hasMoreComments: hasMore,
            }
        }
        case resetContractComments:
            return {
                ...state,
                contractComments: [],
                hasMoreComments: false,
                pageIndex: 1
            }

        case setDefaultContract:
            return initialState;
        default:
            return state;
    }
}